// @flow

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

export const initErrorReportingAgent = (
  dsn: string,
  buildEnvironment: string,
) => {
  Sentry.init({
    dsn,
    environment: buildEnvironment,
    integrations: [new Integrations.ExtraErrorData()],
  })
}
